import styled, {css} from 'styled-components';
import {mediaHeights} from '../../constants/media'
import {DARK_MODE_BORDER, DARK_MODE_HEADER_BACKGROUND, DARK_MODE_TEXT_COLOR} from "../../constants/colorScheme";

const StyledContainer = styled.div`
    width: 360px;
    
    ${mediaHeights.res720`
        width: 280px;
    `};
    
    position: absolute;
    top: 45%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    
    .login-form {    
        border: ${props => props.darkMode ? DARK_MODE_BORDER : '1px solid #eee'};
        padding: 30px 20px 10px;
        border-radius: 5px;
        box-shadow: 2px 2px 20px 8px rgba(0, 0, 0, 0.15);
        ${props => props.darkMode ? 'background: #141414' : ''}
    }    
    
    .login-form-forgot {
        float: right;
    }
    
    .login-form-button {
        width: 100%;
        border-radius: 6px;
    }
    
    .login-logo {
        text-align: center;
        position: relative;
        left: 80px;      
        margin-bottom: 15px;  
        
        ${mediaHeights.res720`
            left: 40px;
        `};
    }
    
    .login-button-form-item {
        flex-direction: row-reverse;
    }
    
     ${props => props.darkMode && css`
        .ant-form-item-label > label {
            color: rgba(255,255,255,.65);
        }
        .ant-form-item-control-input input, .ant-input-affix-wrapper {
            background-color: ${DARK_MODE_HEADER_BACKGROUND} !important;
            color: ${DARK_MODE_TEXT_COLOR} !important;               
            border: ${DARK_MODE_BORDER};
        }
        svg {
            color: ${DARK_MODE_TEXT_COLOR} !important;           
        }
        `}
    }
`;

export default StyledContainer;